import { render } from "./IndovinaStatoView.vue?vue&type=template&id=73f3c460&class=template"
import script from "./IndovinaStatoView.vue?vue&type=script&lang=js"
export * from "./IndovinaStatoView.vue?vue&type=script&lang=js"

import "./IndovinaStatoView.vue?vue&type=style&index=0&id=73f3c460&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__